import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose Tailwind class names with conditional logic AND deduplicate
 * conflicting utilities. Use this for every `className` that mixes a
 * default with conditional/prop-driven classes.
 *
 * @example
 * <div className={cn('px-4 py-2', isActive && 'bg-brand-primary text-white')} />
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
